import { ORDER_APIS } from "@/api_framework/api_config";
import { ICentralOrderPaymentLinkResponse } from "@/api_framework/api_modals/Orders";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import { useAPIUtils } from "../../useAPIUtils";
import { useConfiguration } from "../../useConfiguration";

AxiosCurlirize(axios, () => {});

export const useCentralOrderPaymentLinkAPI = () => {
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(async (orderId: string) => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      const response = await axios
        .get(`${ORDER_APIS?.CENTRAL_ORDER_PAYMENT_LINK?.baseURL}${orderId}`, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<ICentralOrderPaymentLinkResponse>) => res.data)
        .catch((e: AxiosError) => {
          sendCurl(e.config["curlCommand"]);
          captureError(e);
          return null;
        });
      return response;
    } catch (e: any) {
      return null;
    }
  }, []);
  return { execute };
};
